export const governance_oversight = [
  {
    id: 1,
    name: 'Building Standards Act',
    summary: 'shortsummary/building_standards_act.html',
    link: 'building_standards_act.pdf',
    audio_en: 'audio/en/building_standards_act_en.mp3',
    audio_af: 'audio/af/building_standards_act_af.mp3',
    audio_xh: 'audio/xh/building_standards_act_xh.mp3'
  },
  {
    id: 2,
    name: 'GRPB-framework-250119A',
    summary: 'shortsummary/GRPB-framework-250119A.html',
    link: 'GRPB-framework-250119A.pdf',
    audio_en: 'audio/en/GRPB-framework-250119A_en.mp3',
    audio_af: 'audio/af/GRPB-framework-250119A_af.mp3',
    audio_xh: 'audio/xh/GRPB-framework-250119A_xh.mp3'
  },
  {
    id: 3,
    name: 'IPDMArt3ValueFormoney',
    summary: 'shortsummary/IPDMArt3ValueFormoney.html',
    link: 'IPDMArt3ValueFormoney.pdf',
    audio_en: 'audio/en/IPDMArt3ValueFormoney_en.mp3',
    audio_af: 'audio/af/IPDMArt3ValueFormoney_af.mp3',
    audio_xh: 'audio/xh/IPDMArt3ValueFormoney_xh.mp3'
  },
  {
    id: 4,
    name: 'King-IV-Summary-1-November-2016',
    summary: 'shortsummary/King-IV-Summary-1-November-2016.html',
    link: 'King-IV-Summary-1-November-2016.pdf',
    audio_en: 'audio/en/King-IV-Summary-1-November-2016_en.mp3',
    audio_af: 'audio/af/King-IV-Summary-1-November-2016_af.mp3',
    audio_xh: 'audio/xh/King-IV-Summary-1-November-2016_xh.mp3'
  },
  {
    id: 5,
    name: 'MFMA',
    summary: 'shortsummary/MFMA.html',
    link: 'MFMA.pdf',
    audio_en: 'audio/en/MFMA_en.mp3',
    audio_af: 'audio/af/MFMA_af.mp3',
    audio_xh: 'audio/xh/MFMA_xh.mp3'
  },
  {
    id: 6,
    name: 'PFMA',
    summary: 'shortsummary/PFMA.html',
    link: 'PFMA.pdf',
    audio_en: 'audio/en/PFMA_en.mp3',
    audio_af: 'audio/af/PFMA_af.mp3',
    audio_xh: 'audio/xh/PFMA_xh.mp3'
  },
  {
    id: 7,
    name: 'Policy framework for the gwme system',
    summary: 'shortsummary/policy framework for the gwme system.html',
    link: 'policy framework for the gwme system.pdf',
    audio_en: 'audio/en/policy_framework_for_the_gwme_system_en.mp3',
    audio_af: 'audio/af/policy_framework_for_the_gwme_system_af.mp3',
    audio_xh: 'audio/xh/policy_framework_for_the_gwme_system_xh.mp3'
  },
  {
    id: 8,
    name: 'Specification for OHS - Nov draft',
    summary: 'shortsummary/Specification for OHS - Nov draft.html',
    link: 'Specification for OHS - Nov draft.pdf',
    audio_en: 'audio/en/Specification_for_OHS_-_Nov_draft_en.mp3',
    audio_af: 'audio/af/Specification_for_OHS_-_Nov_draft_af.mp3',
    audio_xh: 'audio/xh/Specification_for_OHS_-_Nov_draft_xh.mp3'
  }
];